import React, { useEffect, createRef, useRef } from "react";
import PropTypes from "prop-types";
import Cookies from "universal-cookie";
import { useTranslation } from "react-i18next";
import { utilities } from "@/_helpers";
import { useParams } from "react-router-dom";
import "./GoogleMaps.css";

import LS_LocationsIcon from "../_images/locicons/LS_LocationsIcon.png";
// import LS_PartnerIcon from "../_images/partnericons/LS_PartnerIcon.png";
import LS_SameDayIcon from "../_images/samedayicons/LS_SameDayIcon.png";
import Guard_LocationsIcon from "../_images/locicons/Guard_LocationsIcon.png";
// import Guard_PartnerIcon from "../_images/partnericons/Guard_PartnerIcon.png";
import Guard_SameDayIcon from "../_images/samedayicons/Guard_SameDayIcon.png";
import Mon_LocationsIcon from "../_images/locicons/Mon_LocationsIcon.png";
// import Mon_PartnerIcon from "../_images/partnericons/Mon_PartnerIcon.png";
import Mon_SameDayIcon from "../_images/samedayicons/Mon_SameDayIcon.png";
import QS_LocationsIcon from "../_images/locicons/QS_LocationsIcon.png";
// import QS_PartnerIcon from "../_images/partnericons/QS_PartnerIcon.png";
import QS_SameDayIcon from "../_images/samedayicons/QS_SameDayIcon.png";
// import HomeIcon from '@mui/icons-material/Home';

import {
  LifeSafer,
  Monitech,
  Guardian,
  QuickStart,
} from "../_helpers/BrandConstants";
import { brandColors } from "./brandedComponent/BrandedColors";
import VanIcon from "../_images/vanicons/VanIcon.png";
import SameDayVanIcon from "../_images/vanicons/SameDayVanIcon.png";
import QS_VanIcon from "../_images/vanicons/QS_VanIcon.png";
import QS_SameDayVanIcon from "../_images/vanicons/QS_SameDayVanIcon.png";
import Mon_VanIcon from "../_images/vanicons/Mon_VanIcon.png";
import Mon_SameDayVanIcon from "../_images/vanicons/Mon_SameDayVanIcon.png";
import Guard_VanIcon from "../_images/vanicons/Guard_VanIcon.png";
import Guard_SameDayVanIcon from "../_images/vanicons/Guard_SameDayVanIcon.png";
import { langConversionHelper } from "../_helpers/langConversionHelper";

const GOOGLE_MAP_API_KEY = process.env.REACT_APP_GOOGLE_KEY;
const GOOGLE_MAP_ID = process.env.REACT_APP_GOOGLE_MAP_ID;

export const GoogleMaps = ({
  defaultCenter,
  locationMarkers,
  locations,
  selectedLocation,
  isLoaded,
  selectedLocationId,
}) => {
  const { t, i18n } = useTranslation();
  const cookies = new Cookies();
  const brand = cookies.get("lsEnrollmentReferral") || LifeSafer;
  const { storyName } = useParams();

  const googleMapRef = createRef();
  const googleMap = useRef(null);
  const markerRefs = useRef([]);
  const transformLanguage = (languageID) => {
    let returnLanguageNames = [];

    if (!languageID) return "";

    let languageIDs = languageID?.split(",").map((id) => id.trim());

    languageIDs.forEach((id) => {
      const displayName = langConversionHelper.getLanguageDisplayName(
        id,
        i18n.language,
      );
      if (displayName) returnLanguageNames.push(displayName);
    });
    return returnLanguageNames.join(", ");
  };
  // default to LS
  let locationsIconUrl = LS_LocationsIcon;
  // let partnerIconUrl = LS_PartnerIcon;
  let sameDayIconUrl = LS_SameDayIcon;
  if (brand === Guardian) {
    locationsIconUrl = Guard_LocationsIcon;
    // partnerIconUrl = Guard_PartnerIcon;
    sameDayIconUrl = Guard_SameDayIcon;
  } else if (brand === Monitech) {
    locationsIconUrl = Mon_LocationsIcon;
    // partnerIconUrl = Mon_PartnerIcon;
    sameDayIconUrl = Mon_SameDayIcon;
  } else if (brand === QuickStart) {
    locationsIconUrl = QS_LocationsIcon;
    // partnerIconUrl = QS_PartnerIcon;
    sameDayIconUrl = QS_SameDayIcon;
  }

  const createGoogleMap = () => {
    if (!window.google || !window.google.maps || !window.google.maps.Map)
      return null;
    return new window.google.maps.Map(googleMapRef.current, {
      zoom: 10,
      center: defaultCenter,
      mapTypeControl: false,
      mapId: GOOGLE_MAP_ID,
      streetViewControl: false,
    });
  };
  const updateGoogleMap = () => {
    const center = new window.google.maps.LatLng(
      defaultCenter.lat,
      defaultCenter.lng,
    );
    googleMap.current.panTo(center);
  };

  useEffect(() => {
    const buttons = document.querySelectorAll(".ank-select-location-btn");
    const changeMilesLanguage = document.querySelectorAll(
      ".changeMilesLanguage",
    );
    buttons.forEach((btn) => {
      btn.innerHTML = t("outro.select");
    });
    changeMilesLanguage.forEach((elem) => {
      elem.innerHTML = t("steps.milesAway");
    });
  }, [i18n.language, locationMarkers, isLoaded]);

  // const { isLoaded } = useJsApiLoader({
  //   googleMapsApiKey: process.env.REACT_APP_GOOGLE_KEY,
  // });

  const createMarkers = () => {
    if (
      !window.google ||
      !window.google.maps ||
      !window.google.maps.Size ||
      !window.google.maps.Point ||
      !window.google.maps.marker
    )
      return null;

    if (markerRefs.current.length > 0) {
      markerRefs.current.forEach((marker) => {
        marker.map = null;
      });
      markerRefs.current = [];
    }
    const markerIcon = {
      url: locationsIconUrl,
      scaledSize: new window.google.maps.Size(50, 50),
      origin: new window.google.maps.Point(0, 0),
      anchor: new window.google.maps.Point(0, 15),
    };
    const sameDayIcon = {
      url: sameDayIconUrl,
      scaledSize: new window.google.maps.Size(50, 50),
      origin: new window.google.maps.Point(0, 0),
      anchor: new window.google.maps.Point(0, 15),
    };
    // comment for now
    // const homeIcon = {
    //   path: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z",
    //   fillColor: "#00798c",
    //   fillOpacity: 1,
    //   strokeWeight: 0,
    //   scale: 1.5,
    //   anchor: new window.google.maps.Point(12, 20),
    // };
    // const partnerIcon = {
    //   url: partnerIconUrl,
    //   scaledSize: new window.google.maps.Size(50, 50),
    //   origin: new window.google.maps.Point(0, 0),
    //   anchor: new window.google.maps.Point(0, 15),
    // };

    const infoWindow = new window.google.maps.InfoWindow();

    let sameDayVanIconAltUrl = SameDayVanIcon;
    if (brand === LifeSafer) {
      sameDayVanIconAltUrl = SameDayVanIcon;
    } else if (brand === Guardian) {
      sameDayVanIconAltUrl = Guard_SameDayVanIcon;
    } else if (brand === Monitech) {
      sameDayVanIconAltUrl = Mon_SameDayVanIcon;
    } else if (brand === QuickStart) {
      sameDayVanIconAltUrl = QS_SameDayVanIcon;
    }

    let vanIconAltUrl = VanIcon;
    if (brand === LifeSafer) {
      vanIconAltUrl = VanIcon;
    } else if (brand === Guardian) {
      vanIconAltUrl = Guard_VanIcon;
    } else if (brand === Monitech) {
      vanIconAltUrl = Mon_VanIcon;
    } else if (brand === QuickStart) {
      vanIconAltUrl = QS_VanIcon;
    }

    locationMarkers?.forEach((loc) => {
      // let thisIcon = markerIcon;
      const img = document.createElement("img");
      const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      let imagePath = img;
      img.src = markerIcon.url;
      let adjustedPosition = { lat: loc.lat, lng: loc.lng };
      // comment for now

      // if (loc?.sameDay) {
      //   thisIcon = sameDayIcon;
      // }
      // if (loc?.isHome) {
      //   thisIcon = homeIcon;
      // } else if (loc?.label === "Mobile Location" || loc?.label === "Mobile") {
      //   if (loc?.sameDay) {
      //     thisIcon = {
      //       url: sameDayVanIconAltUrl,
      //       scaledSize: new window.google.maps.Size(50, 25),
      //       origin: new window.google.maps.Point(0, 0),
      //       anchor: new window.google.maps.Point(25, 50),
      //     };
      //   } else {
      //     thisIcon = {
      //       url: vanIconAltUrl,
      //       scaledSize: new window.google.maps.Size(50, 25),
      //       origin: new window.google.maps.Point(0, 0),
      //       anchor: new window.google.maps.Point(25, 50),
      //     };
      //   }
      //   adjustedPosition = { lat: loc.lat, lng: loc.lng };
      // } else if (loc?.sameDay) {
      //   thisIcon = sameDayIcon;
      // }

      if (loc?.sameDay) {
        img.src = sameDayIcon.url;
      }
      if (loc?.isHome) {
        // img.src = homeIcon.path;
        svg.setAttribute("viewBox", "0 0 24 24");
        svg.setAttribute("width", "36");
        svg.setAttribute("height", "36");

        const path = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "path",
        );
        path.setAttribute("d", "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z");
        path.setAttribute("fill", "#00798c");

        svg.appendChild(path);
        svg.style.transform = "translate(-50%, -100%)";
      } else if (loc?.label === "Mobile Location" || loc?.label === "Mobile") {
        if (loc?.sameDay) {
          img.src = sameDayVanIconAltUrl;
        } else {
          img.src = vanIconAltUrl;
        }
        adjustedPosition = { lat: loc.lat, lng: loc.lng };
      } else if (loc?.sameDay) {
        img.src = sameDayIcon.url;
      }

      imagePath = loc?.isHome ? svg : img;
      img.style.width = "50px";
      img.style.height = "50px";
      const isSelected =
        selectedLocationId !== null &&
        selectedLocationId !== undefined &&
        String(selectedLocationId) === String(loc.key);
      img.style.filter = isSelected ? "brightness(60%)" : "none";

      const marker = new window.google.maps.marker.AdvancedMarkerElement({
        title: loc.title,
        // animation: window.google.maps.Animation.DROP,
        position: adjustedPosition,
        map: googleMap.current,
        content: imagePath,
      });
      markerRefs.current.push(marker);

      marker.customId = loc.key;
      const selectBtn = document.createElement("button");
      const selectBtns = document.createElement("div");
      selectBtns.appendChild(selectBtn);
      selectBtns.style.display = "flex";
      selectBtns.style.justifyContent = "center";
      selectBtns.style.marginLeft = "35px";
      selectBtn.innerHTML = t("outro.select");
      selectBtn.className = "ank-select-location-btn";
      selectBtn.id = marker.customId;
      selectBtn.style.backgroundColor = brandColors[brand].primary;
      selectBtn.style.boxShadow =
        "0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)";
      selectBtn.style.color = "#fff";
      selectBtn.style.border = "none";
      selectBtn.style.padding = "6px 12px";
      selectBtn.style.cursor = "pointer";
      selectBtn.style.fontSize = "0.8125rem";
      selectBtn.style.borderRadius = "4px";
      selectBtn.style.textTransform = "uppercase";

      if (marker.customId !== "Home") {
        marker.addListener("gmp-click", () => {
          // infoWindow.close();
          // infoWindow.setContent(infoWindowContent(marker.customId, selectBtns));
          // infoWindow.open(marker.getMap(), marker);
          // Top shift popup description design Upward only when google marker is clicked else not
          infoWindow.close();
          infoWindow.setContent(infoWindowContent(loc, selectBtns));
          infoWindow.open({
            map: googleMap.current,
            anchor: marker,
          });
          setTimeout(() => {
            const container = document.querySelector(
              ".ank-google-maps-holder .gm-style-iw-d",
            );
            if (!container) return;
            container.style.marginTop = "-52px";
            container.style.maxHeight = "none !important";
          }, 10);
        });
      }

      selectBtns.addEventListener("click", (e) => {
        const locationInfo = locations.find(
          (x) => x.locationID === parseInt(e.target.id),
        );
        selectedLocation(locationInfo);
      });
    });
  };

  const infoWindowContent = (locId, inputEl) => {
    const locationInfo = locations.find(
      (x) => x.locationID === parseInt(locId?.key),
    );

    if (!locationInfo) return null;
    const mainHeader = document.createElement("h2");
    mainHeader.className = "ank-h2";
    mainHeader.innerHTML = locationInfo?.displayName;

    const mainDiv = document.createElement("div");
    mainDiv.className = "description";

    const locDescription = document.createElement("p");
    locDescription.className = "removeMargin";
    locDescription.innerHTML = `${locationInfo?.address1} ${
      locationInfo?.address2 || ""
    }`;

    const locDescription2 = document.createElement("p");
    locDescription2.className = "removeMargin";
    locDescription2.innerHTML = `${locationInfo?.city}, ${locationInfo?.state} ${locationInfo?.zip}`;

    const locDescription3 = document.createElement("p");
    locDescription3.className = "removeMargin";
    locDescription3.innerHTML = utilities.formatPhoneNumber(
      locationInfo?.phone1,
    );

    const locDescription4 = document.createElement("p");
    locDescription4.className = "removeMargin";
    locDescription4.innerHTML = transformLanguage(locationInfo?.languages);

    const locDescription5 = document.createElement("p");
    locDescription5.className = "removeMargin";
    locDescription5.innerHTML = locationInfo?.distanceFromHome
      ? `${locationInfo.distanceFromHome.toFixed(1)}` +
        ` <span class="changeMilesLanguage"> ${t("steps.milesAway")} </span>`
      : null;

    mainDiv.appendChild(locDescription);
    mainDiv.appendChild(locDescription2);
    mainDiv.appendChild(locDescription3);
    mainDiv.appendChild(locDescription4);
    mainDiv.appendChild(locDescription5);
    mainHeader.append(mainDiv);
    mainHeader.append(inputEl);

    return mainHeader;
  };

  useEffect(() => {
    if (window.google && window.google.maps && googleMapRef.current) {
      createGoogleMap();
      createMarkers();
      return;
    }

    const existingScript = document.querySelector(
      `script[src*="maps.googleapis.com/maps/api/js"]`,
    );
    if (!existingScript) {
      const script = document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAP_API_KEY}&libraries=places,marker&loading=async`;
      script.async = true;
      script.defer = true;

      document.head.appendChild(script);
    }
  }, []);

  useEffect(() => {
    if (isLoaded && googleMapRef.current) {
      googleMap.current = createGoogleMap();
      if (googleMap.current) {
        createMarkers();
      }
    }
  }, [isLoaded, locationMarkers, i18n.language, selectedLocationId]);

  useEffect(() => {
    if (googleMap.current) {
      updateGoogleMap();
      createMarkers();
    }
  }, [isLoaded, locationMarkers, i18n.language, selectedLocationId]);

  return (
    <div
      id="google-map"
      ref={googleMapRef}
      className={
        // storyName?.toLowerCase() !== "location" ? "mapStyles" : "mapFull"
        storyName?.toLowerCase() !== "location" ? "mapFull" : "mapFull"
      }
    />
  );
};

GoogleMaps.propTypes = {
  defaultCenter: PropTypes.object.isRequired,
  locationMarkers: PropTypes.array,
  locations: PropTypes.array,
  selectedLocation: PropTypes.func.isRequired,
  isLoaded: PropTypes.bool,
  selectedLocationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
